import React, { PureComponent, Component, ChangeEvent } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import { dialogActions } from '../../actions/dialog.actions';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'

import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux'
import DialogActions from '@material-ui/core/DialogActions';
import { connect } from 'react-redux'
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { ThunkDispatch } from 'redux-thunk';
import TextField from '@material-ui/core/TextField';

import { green } from '@material-ui/core/colors';
import { isPhasePlanDialogOpen } from '../../selectors/dialog.selector';
import { phasePlanActions } from '../../actions/phaseplan.actions';




const theme = createMuiTheme({
    palette: {
        primary: green,
    },
})

export interface ContentProps {
    onSubmit: (name: string) => any
    onClose: () => void,
    classes: ClassNameMap,
}

type ContentState = {
    name: string,
    errored: boolean

}

class PhasePlanDialogContent extends PureComponent<ContentProps, ContentState> { 
    
    readonly state = { 
        name: '',
        errored: false
    }

    editPhasePlan = () => {
        const { name } = this.state
        if(!name|| name.length === 0) {
            this.setState({
                errored: true
            })
            return
        }

        this.props.onSubmit(this.state.name)
    }

    onClose = () => {
        const { onClose } = this.props

        onClose()
    }

    handleChange = async (event:ChangeEvent<HTMLInputElement>) => {


        const newName:string = !!event.target.value ? event.target.value : ""

        this.setState({
            name: newName,
            errored: false
        })
    };

    getErrorText = () => {
        const { errored } = this.state
        if(!!errored) {
            return "Name Can't Be Empty"
        }
    }


    

    render() {
        const { classes } = this.props
        const { name, errored } = this.state
        return (
            <React.Fragment>
                <DialogContent>
                    <div className={classNames(classes.deleteDialog)}>
                        Phase Plan
                    </div>
                    <TextField 
                        helperText={this.getErrorText()} 
                        error={errored} 
                        fullWidth={true} 
                        value={name}  
                        onChange={this.handleChange} 
                        label="Name" 
                        margin="dense" 
                    />
                </DialogContent>
                <MuiThemeProvider theme={theme}>
                    <DialogActions>
                            <Button onClick={this.onClose} color="secondary"> Cancel </Button>
                            <Button onClick={this.editPhasePlan} color="primary">Ok</Button>
                    </DialogActions>
                </MuiThemeProvider>
            </React.Fragment>
        )
    }
}

export interface Props {
    isPhasePlanDialogOpen: boolean,
    classes: ClassNameMap,
    closePhasePlanDialog: () => Promise<void>,
    savePlanValue: (phasePlanId:string | null, name:string) => Promise<void>,
}

const PhasePlanDialog: React.FunctionComponent<Props> =
    ({ isPhasePlanDialogOpen, closePhasePlanDialog, classes, savePlanValue }) => {
        
        const closeDialog = () => {
            return async () => {
                closePhasePlanDialog()
            }
        }

        const savePhasePlan = async (name: string) => {
            

            savePlanValue(null, name)
            closePhasePlanDialog()
        }

        return (
            <Dialog
                open={isPhasePlanDialogOpen}
                onBackdropClick={closeDialog()}
            >
                <PhasePlanDialogContent 
                    classes={classes} 
                    onSubmit={savePhasePlan} 
                    onClose={closePhasePlanDialog} 
                />
            </Dialog>
        )
    }

const mapStateToProps = (state: any) => ({
    isPhasePlanDialogOpen: isPhasePlanDialogOpen(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closePhasePlanDialog: () => dispatch(dialogActions.closePhasePlanDialog()),
        savePlanValue: (phasePlanId:string | null, name:string) => 
            dispatch(phasePlanActions.savePhasePlan(phasePlanId, name))
    }
};
export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, mapDispatchToProps),
)(PhasePlanDialog);



// WEBPACK FOOTER //
// ./src/components/Dialogs/PhasePlanDialogContainer.tsx